module.exports = __webpack_public_path__ + "img/item3b.cae99988.png";